import Text from './Text';

export { type TextProps } from './Text';
export default Text;
